<div (click)="showPicker = !showPicker" [style.background]="selectedColor" class="color-circle"></div>

<div *ngIf="showPicker" class="color-picker">
  <div (click)="selectColor(color)" *ngFor="let color of colors" [style.background]="color" class="color-box"></div>
</div>
